import "../theme/AdministracionCatalogo.css";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import { authProvider } from "../context/authProvider";
import { TableAdministracionRegistroATB } from "../components/TableAdministracionRegistroATB";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const VistaATB = () => {
  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <BtnGoBack caption="Terminales Bancarias" />
              </div>
              <TableAdministracionRegistroATB />
            </div>
          );
        }
      }}
    </OktaIDP>
  );
};
